<div class="d-flex align-items-start gap-2 reasoning-step">
  <span class="d-flex align-items-center justify-content-center">
    @if (isStreaming()) {
    <span class="reasoning-step__spinner"></span>
    } @else {
    <mat-icon class="mat-icon-sm mat-text-primary">check_circle</mat-icon>
    }
  </span>
  <div class="d-flex flex-column gap-1">
    <span class="mat-font-label-md mat-text-on-surface-variant">{{ stepInfo().stepLabel }}</span>
    @if (stepInfo().description) {
    <span class="mat-font-body-sm mat-text-on-surface-variant">{{ stepInfo().description }}</span>
    }
  </div>
</div>
